module.exports = __webpack_public_path__ + "img/蒙版左.4368b77b.png";